import { processCandidate } from '../loadorgchart.js';
import { UtilityFunctions } from './utility-functions.js';

class DrawOrgCharts {
  viewOrgChartCompanyCard(elem) {
    console.log("new DrawOrgCharts().viewOrgChartCompanyCard FUNCTION CALLED");
    company_id_selected = elem.getAttribute("company_id");
    company_name_selected = elem.getAttribute("company_name");
    console.log(elem);
    var token_obj = {};
    token_obj["company_name_selected"] = company_name_selected;
    token_obj["company_id_selected"] = company_id_selected;
    updateStorageToken(token_obj, "viewOrgChartCompanyCard_token_obj");
    new Toggle().toggleOrgCharts();
  }
  setupOrgChartItems() {
    var flask_jinja_obj = document.getElementById("org_data").getAttribute("data-row");
    // console.log(flask_jinja_obj)
    var parsed_flask_jinja_obj = JSON.parse(flask_jinja_obj);
    console.log(parsed_flask_jinja_obj);
    if (parsed_flask_jinja_obj["query_status"] == "unauthorized") {
      console.log("Some problem");
    } else {
      console.log("Going to setup draw org chart and also going to try to setup response nodes");
      var org_data = parsed_flask_jinja_obj["results"]["data"]["modified_query_results"];
      console.log(org_data);
      new DrawOrgCharts().drawOrgchart(org_data);
      var response_params = parsed_flask_jinja_obj["response_params"];
      console.log(response_params);
      this.setUpSessionStorageOrgChartVariables(org_data);
      console.log("Starting to try to modify multiple nodes");
      // console.log("These are the response params", response_params)
      var response_nodes = response_params["past_data"] ? response_params["past_data"] : [];
      console.log("response_nodes is ::", response_nodes);
      if (response_nodes.length > 0) {
        processMultipleNodes(parsed_flask_jinja_obj, response_nodes, org_data);
      } else {
        // handleIncompleteResponse(response)
        console.log("No past data found for this org chart");
      }
    }
  }
  clearOrgChartFunctionGradeTokens() {
    try {
      var existing_tokens = JSON.parse(sessionStorage["query"]);
      existing_tokens["functions"] = [];
      existing_tokens["grades"] = [];
      sessionStorage["query"] = JSON.stringify(existing_tokens);
    } catch (error) {
      console.log("Error:", error);
    }
  }
  companyIdsNamesFromResponseObj(response) {
    console.log("This is the company Ids Names from Response::", response);
    var company_ids_arr = [];
    var company_names_arr = [];

    for (var i = 0; i < response["results"]["data"]["modified_query_results"].length; i++) {
      company_ids_arr.push(response["results"]["data"]["modified_query_results"][i]["id"]);
      company_names_arr.push(response["results"]["data"]["modified_query_results"][i]["name"]);
    }
    return [company_ids_arr, company_names_arr];
  }

  setUpSessionStorageOrgChartVariables(data) {
    sessionStorage["org_chart_data_company_name"] = data["company_name"];
    sessionStorage["org_chart_data_company_id"] = data["company_id"];
    sessionStorage["org_chart_data_countries"] = data["countries"];
    // sessionStorage['functions_analytics'] = data['functions_analytics']
    sessionStorage["location_analytics"] = data["location_analytics"] != null ? data["location_analytics"] : "{}";
    try {
      sessionStorage["org_chart_data_for_panel"] = JSON.stringify(data);
    } catch (e) {
      sessionStorage["org_chart_data_for_panel"] = "{}";
    }
  }

  getAllCountriesFromLocationAnalytics() {
    var all_locations = [];
    try {
      var raw = sessionStorage["location_analytics"];
      if (raw != null && raw !== "" && raw !== "undefined") {
        all_locations = Object.keys(JSON.parse(raw));
      }
    } catch (e) {}
    var all_countries = [];
    for (var i = 0; i < all_locations.length; i++) {
      var country = all_locations[i].split(", ")[2];
      if (!(all_countries.includes(country) || country == undefined)) {
        all_countries.push(country);
      }
    }
    all_countries.sort();
    return all_countries;
  }

  getRegionsFromCountry(country_name) {
    try {
      var raw = sessionStorage["location_analytics"];
      if (raw == null || raw === "" || raw === "undefined") return [];
      var all_locations = Object.keys(JSON.parse(raw));
    } catch (e) {
      var all_locations = [];
    }
    var all_regions = [];
    for (var i = 0; i < all_locations.length; i++) {
      var country = all_locations[i].split(", ")[2];
      var region = all_locations[i].split(", ")[1];
      if ((country == country_name) & !all_regions.includes(region)) {
        all_regions.push(region);
      }
    }
    all_regions.sort();
    return all_regions;
  }

  getLocalitiesfromCountryAndRegion(country_name, region_name) {
    let all_localities = [];
    let all_locations = [];
    try {
      var raw = sessionStorage["location_analytics"];
      if (raw != null && raw !== "" && raw !== "undefined") {
        all_locations = Object.keys(JSON.parse(raw));
      }
    } catch (e) {}

    for (var i = 0; i < all_locations.length; i++) {
      let country = all_locations[i].split(", ")[2];
      let region = all_locations[i].split(", ")[1];
      let locality_name = all_locations[i].split(", ")[0];
      if ((country == country_name) & (region == region_name) & (locality_name != undefined)) {
        all_localities.push(locality_name);
      }
    }
    all_localities.sort();
    return all_localities;
  }

  getCompanyNamefromQueryObj() {
    var query_obj = JSON.parse(sessionStorage["query"]);
    console.log("This is query", query_obj);
    let company_name;
    if (query_obj["company_name"].length > 0) {
      company_name = query_obj["company_name"][0]["name"];
    } else if (query_obj["company_id"].length > 0 && query_obj["company_name"].length == 0) {
      company_name = query_obj["company_id"][0]["name"];
    }
    return company_name;
  }

  changeCountryModalOpen() {
    console.log("changeCountry FUNCTION CALLED");
    $(change_country_modal).modal("show");
  }

  confirmCountrySelection() {
    $(change_country_modal).modal("hide");
    console.log("country selection done");
  }

  cancelCountrySelection() {
    $(change_country_modal).modal("hide");
    console.log("country selection done");
  }

  createOrgChartVisualizer(org_data, account_name) {
    console.log("Got to createOrgChartVisualizerreate");
    var elms = document.querySelectorAll("[id='current_account_name']");
    var elms_func = document.querySelectorAll("[id='functional_dropdown_container']");
    var elms_geo = document.querySelectorAll("[id='geo_dropdown_container']");
    var elms_arrow = document.querySelectorAll("[id='arrow_panel']");
    var linkedin_url_elems = document.querySelectorAll("[id='contact_card_linkedin_link_org_chart_header']");
    var linkedin_url = org_data["job_company_linkedin_url"] || org_data["linkedin_url"];
    var website = org_data["website"] || org_data["job_company_website"];
    try {
      for (var i = 0; i < linkedin_url_elems.length; i++) {
        var el = linkedin_url_elems[i];
        if (!el) continue;
        if (linkedin_url) {
          var href = linkedin_url.indexOf("http") === 0 ? linkedin_url : "https://" + linkedin_url.replace(/^https?:\/\//, "");
          el.setAttribute("onclick", "window.open('" + href.replace(/'/g, "\\'") + "', '_blank')");
          el.style.display = "inline-flex";
        } else {
          el.style.display = "none";
        }
      }
    } catch (error) {
      console.log("Error:", error);
    }
    var websiteLinkEls = document.querySelectorAll("[id='org_chart_company_website_link']");
    var websiteHref = website && !linkedin_url
      ? (website.indexOf("http") === 0 ? website : "https://" + website.replace(/^https?:\/\//, ""))
      : "";
    for (var w = 0; w < websiteLinkEls.length; w++) {
      if (websiteHref) {
        websiteLinkEls[w].href = websiteHref;
        websiteLinkEls[w].style.display = "inline-flex";
      } else {
        websiteLinkEls[w].style.display = "none";
      }
    }
    var industry = org_data["industry"];
    var size = org_data["size"];
    var countOrg = org_data["count_org"];
    var country = org_data["country"] || org_data["region"];
    var locality = org_data["locality"];
    var locationParts = [locality, country].filter(Boolean);
    var locationName = locationParts.length ? locationParts.join(", ") : (country || "");
    var websiteDomain = "";
    if (website) {
      try {
        var withProtocol = website.indexOf("http") === 0 ? website : "https://" + website;
        var urlObj = new URL(withProtocol);
        websiteDomain = urlObj.hostname.replace(/^www\./, "");
      } catch (e) {
        websiteDomain = website;
      }
    }
    var metaParts = [];
    if (locationName) metaParts.push(locationName);
    if (industry) metaParts.push(industry);
    if (websiteDomain) metaParts.push(websiteDomain);
    if (size != null && size !== "") metaParts.push(Number(size).toLocaleString() + " employees");
    if (countOrg != null && countOrg !== "") metaParts.push(Number(countOrg).toLocaleString() + " profiles");
    var metaHtml = metaParts.length > 0 ? metaParts.join(" &middot; ") : "";
    var metaRowEls = document.querySelectorAll("[id='org_chart_company_meta_row']");
    for (var m = 0; m < metaRowEls.length; m++) {
      metaRowEls[m].innerHTML = metaHtml;
      metaRowEls[m].style.display = metaParts.length > 0 ? "flex" : "none";
    }
    for (var i = 0; i < elms.length; i++) {
      try {
        elms[i].innerHTML = account_name;
      } catch (error) {
        console.log("Error:", error);
      }
    }
    var funcDropdownEl = document.getElementById("functional_dropdown_element");
    var geoDropdownEl = document.getElementById("geo_dropdown_element");
    if (funcDropdownEl) {
      for (var i = 0; i < elms_func.length; i++) elms_func[i].innerHTML = funcDropdownEl.innerHTML;
    }
    if (geoDropdownEl) {
      for (var i = 0; i < elms_geo.length; i++) elms_geo[i].innerHTML = geoDropdownEl.innerHTML;
    }

    for (var i = 0; i < elms_arrow.length; i++) elms_arrow[i].innerHTML = '<img src="/static/img/arrow_bottom_blue.png" style="height:10px; margin-bottom:5px">';
    // document.getElementById("functional_dropdown_container").innerHTML= document.getElementById("functional_dropdown_element").innerHTML
    // document.getElementById("geo_dropdown_container").innerHTML= document.getElementById("geo_dropdown_element").innerHTML
    var arrowPanel = document.getElementById("arrow_panel");
    if (arrowPanel) arrowPanel.innerHTML = '<img src="/static/img/arrow_bottom_blue.png" style="height:10px; margin-bottom:5px">';
    var height = ($(window).height() * (1 - 0.28)).toString(); // -188
    // var height = ($(window).height()*(1-.21)).toString() // -188
    var width = $(window).width();

    if (width > 600) {
      document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document
        .getElementById("org_chart_visualizer")
        .innerHTML // document.getElementById("banner_element").innerHTML +
        .replace(/{height}/g, height);
    } else if (width < 600) {
      document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document
        .getElementById("org_chart_visualizer")
        .innerHTML // document.getElementById("banner_element").innerHTML +
        .replace(/{height}/g, height);

      // document.getElementById("org_chart_buttons").innerHTML = ''
      document.getElementById("auto_updates_section").innerHTML = "";
    }
  }

  getOrgChartNodeJsonObjWithoutKeyParent(data) {
    // console.log("Got this as data", data)
    for (var i = 0; i < data["candidates"].length; i++) {
      var candidate = data["candidates"][i];
      var [data, candidate] = processCandidate(candidate, data, i);
    }
    data["category"] = "detailed";
    return data;
  }

  getOrgChartNodeJsonObj(array_obj, key, parent) {
    console.log("Got this as array_obj", array_obj);
    for (var i = 0; i < array_obj["candidates"].length; i++) {
      candidate = array_obj["candidates"][i];
      array_obj["key"] = key;
      array_obj["parent"] = parent;
      var [array_obj, candidate] = processCandidate(candidate, array_obj, i);
    }
    array_obj["category"] = "detailed";
    return array_obj;
  }

  getOrgChartJsonObj(org_data) {
    console.log("Got this as get org chart json obj:::", org_data);
    // debugger;
    var orgchart_list_of_arrays = JSON.parse(org_data["orgchart"]).length > 0 ? JSON.parse(org_data["orgchart"]) : [];
    sessionStorage["orgchart_list_of_arrays"] = org_data ? org_data["orgchart"] : JSON.stringify([]);
    // orgchart_list_of_arrays = org_data
    console.log(orgchart_list_of_arrays);
    // console.log(orgchart_list_of_arrays.length);
    var new_array_objs = [];
    var new_array_objs_functions = [];
    // debugger;
    // // Adding this condition to manage the cases where a functional root has been requested and we are sending a bunch load of data from the back. Backend is not managing this appropirately/
    // if (JSON.parse(sessionStorage['query'])['function_root'].length>0 && sessionStorage['selected_context_menu']!=''){
    //     for (var j =0; j< orgchart_list_of_arrays.length;j++) {
    //         var array_obj_functions = orgchart_list_of_arrays[j]
    //         if (JSON.parse(sessionStorage['query'])['function_root'][0]['name'] == array_obj_functions['std_function_root']){
    //             new_array_objs_functions.push(orgchart_list_of_arrays[i])
    //         }
    //         orgchart_list_of_arrays = new_array_objs_functions
    //     }
    // }

    // debugger;
    for (var j = 0; j < orgchart_list_of_arrays.length; j++) {
      var array_obj = orgchart_list_of_arrays[j];
      // console.log(array_obj)
      // console.log(array_obj['headline'])
      if (array_obj["candidates"] != "") {
        for (var i = 0; i < array_obj["candidates"].length; i++) {
          // console.log("this is the JJJ::", j)
          var candidate = array_obj["candidates"][i];
          var [array_obj, candidate] = processCandidate(candidate, array_obj, i);
        }
      } else {
        // console.log("this is the JJJ where length <0::", j)
        var candidate = array_obj;
        var [array_obj, candidate] = processCandidate(candidate, array_obj, i);
      }
      // console.log(array_obj)
      new_array_objs.push(array_obj);
    }
    return new_array_objs;
  }

  drawOrgchart(org_data) {
    console.log("drawOrgchart function called");
    console.log(org_data);

    try {
      var account = org_data["company_name"];
    } catch (error) {
      console.log("Error", error);
      var account = org_data["company_id"];
    }

    var org_chart_data_company_name = sessionStorage["org_chart_data_company_name"];
    console.log(org_chart_data_company_name);
    if (org_chart_data_company_name == "") {
      sessionStorage["org_chart_data_company_name"] = JSON.stringify(org_data["company_name"]);
      sessionStorage["org_chart_data_company_id"] = JSON.stringify(data["company_name"]);
    }

    console.log(account);
    try {
      if (account.length > 15) {
        var account_name = account.slice(0, 15) + "...";
      } else {
        var account_name = account;
      }
    } catch (error) {
      console.log("Error:", error);
    }
    // console.log(account_name)

    // console.log("This is the data_display", org_data['data_display']);
    // console.log("This is the org_data", org_data);
    this.createOrgChartVisualizer(org_data, account_name);
    // console.log(org_data)
    var functions_list = org_data.functions;
    // functions_quantities_list = org_data.functions_analytics
    // total_people = Object.values(org_data.functions_analytics).reduce((a, b) => a + b, 0)
    var total_people = org_data.count_org;
    // console.log(rows);
    try {
      document.getElementById("data_truncation_message").innerHTML = "";
    } catch {
      console.log("no data truncation message");
    }

    myDiagram = loadOrgChartDiagram("myDiagramDiv");

    $(".zoomSlider").css("margin-left", "-50px");
    $(".zoomSlider").css("top", "-100px");
    // $(".zoomSlider").css({'width': '100%', 'height': '150px', 'top': '-20%','float':'right','text-align':'right' })
    // $(".zoomSliderRange").css({'width': '80%', 'transform-origin': '50px 50px', 'transform': 'rotate(-90deg)'})
    // $(".zoomSlider").style = 'width: 100%; height: 150px; top: -20%;float:right;text-align:right;'
    // $(".zoomSliderRange").style = 'width: 80%; transform-origin: 50px 50px; transform: rotate(-90deg);'

    $("#zoomSliderIn").remove();
    $("#zoomSliderOut").remove();
    // console.log(org_data)
    // console.log(org_data['orgchart'])

    var orgchart_list_of_arrays = org_data["orgchart"] ? JSON.parse(org_data["orgchart"]) : [];
    // console.log(orgchart_list_of_arrays)
    var orgchart_json = this.getOrgChartJsonObj(org_data);
    console.log(orgchart_json);
    // console.log(orgchart_json);
    var chart_data = '{ "class": "TreeModel", "nodeDataArray":' + JSON.stringify(orgchart_json) + "}";

    // console.log(chart_data);

    myDiagram.model = go.Model.fromJson(chart_data);
    // make sure new data keys are unique positive integers
    var lastkey = 1;
    myDiagram.model.makeuniqueStringKeyFunction = function (model, data) {
      var k = data.key || lastkey;
      while (model.findNodeDataForKey(k)) k++;
      data.key = lastkey = k;
      return k;
    };
    window.history.pushState(null, null, "/org-chart/" + org_data.company_id);

    // search_results = myDiagram.findNodesByExample(
    //     { headline: regex },
    //     { country: regex },
    //     );
    // Zoom into CEO / tree root (not zoomToFit); defer until div size + layout are ready.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        new UtilityFunctions().centerViewportOnOrgChartRoot();
      });
    });

    // centerToCEO()
    // runWalkThrough()
    console.log("COMPLETED THE ORG CHART BUILDING PROCESS");

    var width = $(window).width();
    document.getElementById("linkedin_icon_header").innerHTML =
      '<g clip-path="url(#a)"> <path d="M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z" fill="#fff"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M1.034 0h11.931C13.537 0 14 .449 14 1.003v11.994C14 13.55 13.537 14 12.965 14H1.035C.462 14 0 13.55 0 12.997V1.003C0 .449.463 0 1.034 0zM2.13 11.72h2.114V5.398H2.13v6.322zm1.057-7.185h-.014c-.709 0-1.168-.486-1.168-1.092 0-.62.473-1.093 1.196-1.093.724 0 1.169.472 1.183 1.093 0 .606-.46 1.092-1.197 1.092zm6.568 7.185h2.114V8.094c0-1.942-1.042-2.845-2.434-2.845-1.122 0-1.625.613-1.906 1.044v-.895H5.414c.028.592 0 6.322 0 6.322h2.114V8.188c0-.19.014-.378.07-.513.153-.377.5-.768 1.085-.768.765 0 1.071.58 1.071 1.429v3.383z" fill="#0077B5"></path> </g> <defs> <clipPath id="a"> <path d="M0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z" fill="#fff"></path> </clipPath> </defs>';
    if (width < 600) {
      document.getElementById("org_chart_buttons").innerHTML = "";
    }
    // Change the load type to query for future queries
    sessionStorage["load_type"] = "query";

    console.log("This is the org data", org_data.countries);

    if (typeof org_data.countries != "undefined") {
      this.setupCountriesDropdownContainer(org_data);
    } else {
      document.getElementById("geo_dropdown_container").innerHTML = "";
    }

    if (typeof org_data.functions != "undefined") {
      this.setupFunctionalDropdownContainer(org_data);
    } else {
      document.getElementById("functional_dropdown_container").innerHTML = "";
    }

    if (["salesforce"].includes(account_name)) {
      this.setupYearsDropdownContainer(org_data);
    }

    mixpanel.track("OrgChartLoaded:", {
      company_name: account,
    });

    try {
      // $('[data-toggle="tooltip"]').tooltip({ placement : 'top'});
      new UtilityFunctions().activateToolTips();
    } catch (error) {
      console.log("Error:", error);
    }

    this.setOrgChartSliderstoNone();
  }

  setOrgChartSliderstoNone() {
    try {
      document.getElementById("myDiagramDiv").children[1].style.overflow = "none";
    } catch (error) {}
  }

  setupYearsDropdownContainer(org_data) {
    var dropdown_options = "";

    // create a state dropdown selector to be able to display only the people in a certain state
    var functional_root_counts = this.getFunctionalRootCounts(org_data);
    var functional_areas = org_data.functions;
    var labels = org_data.functions;
    // function_area_selected = 'full company';
    var function_area_selected = org_data["type"];
    functional_areas.sort();
    var year = "2022";
    // functional_areas = functional_areas.filter(x => x !== 'na');
    // functional_root_counts = getFunctionalRootCounts(org_data)
    // area_selected = sessionStorage['functional_area']
    var sum_root_functional_roots = Object.values(functional_root_counts).reduce((partialSum, a) => partialSum + a, 0);
    functional_root_counts["fullcompany"] = sum_root_functional_roots;
    for (var i = 0, len = 5; i < len; i++) {
      if (!(functional_areas[i].includes("assist") || functional_areas[i] == "na")) {
        var functional_area = functional_areas[i];
        var percent_functional_area_percent = ((functional_root_counts[functional_area] / functional_root_counts["fullcompany"]) * 100).toFixed(1) + "%";
        var percent_value = new UtilityFunctions().isFloat((functional_root_counts[functional_area] / functional_root_counts["fullcompany"]) * 100) ? "(" + percent_functional_area_percent + ")" : "";
        var dropdown_options =
          dropdown_options +
          document
            .getElementById("year_dropdown_option_element")
            .innerHTML.replace(/{year}/g, year - i)
            .replace(/{label}/g, year - i)
            .replace(/{percent_year}/g, "(100%)");
      } else {
      }
    }

    var elms_cont = document.querySelectorAll("[id='year_dropdown_container']");

    if (elms_cont) {
      for (var i = 0; i < elms_cont.length; i++)
        elms_cont[i].innerHTML = document
          .getElementById("year_dropdown_element")
          .innerHTML.replace(/{options}/g, dropdown_options)
          .replace(/{year_selected}/g, year);

      try {
        var label = org_data["type"].toUpperCase();

        document.getElementById("year_panel").innerHTML = label;
      } catch (error) {
        // console.log("Error:", error);
      }
    }
  }

  setupFunctionalDropdownContainer(org_data) {
    var dropdown_options = "";
    // create a state dropdown selector to be able to display only the people in a certain state
    var functional_root_counts = this.getFunctionalRootCounts(org_data);
    var functional_areas = org_data.functions;
    var labels = org_data.functions;
    // function_area_selected = 'full company';
    var function_area_selected = org_data["type"];
    functional_areas.sort();
    // functional_areas = functional_areas.filter(x => x !== 'na');
    // functional_root_counts = getFunctionalRootCounts(org_data)
    // area_selected = sessionStorage['functional_area']
    var sum_root_functional_roots = Object.values(functional_root_counts).reduce((partialSum, a) => partialSum + a, 0);
    functional_root_counts["fullcompany"] = sum_root_functional_roots;
    for (var i = 0, len = functional_areas.length; i < len; i++) {
      if (!(functional_areas[i].includes("assist") || functional_areas[i] == "na")) {
        var functional_area = functional_areas[i];
        var percent_functional_area_percent = ((functional_root_counts[functional_area] / functional_root_counts["fullcompany"]) * 100).toFixed(1) + "%";
        var percent_value = new UtilityFunctions().isFloat((functional_root_counts[functional_area] / functional_root_counts["fullcompany"]) * 100) ? "(" + percent_functional_area_percent + ")" : "";
        var dropdown_options =
          dropdown_options +
          document
            .getElementById("functional_dropdown_option_element")
            .innerHTML.replace(/{functional_area}/g, functional_area)
            .replace(/{label}/g, functional_area)
            .replace(/{percent_functional_area}/g, percent_value);
      } else {
      }
    }
    var elms_cont = document.querySelectorAll("[id='functional_dropdown_container']");
    console.log("Org data is::", org_data.functions);
    for (var i = 0; i < elms_cont.length; i++) {
      elms_cont[i].innerHTML = document
        .getElementById("functional_dropdown_element")
        .innerHTML.replace(/{options}/g, dropdown_options)
        .replace(/{function_area_selected}/g, function_area_selected);
    }

    try {
      var label = org_data["type"].toUpperCase();
      document.getElementById("function_panel").innerHTML = label;
    } catch (error) {
      console.log("Error:", error);
    }
  }

  setupCountriesDropdownContainer(org_data) {
    // create a state dropdown selector to be able to display only the people in a certain state
    // orgchart_json = org_data['json_data']
    // console.log(org_data)
    var dropdown_options = "";
    var countries_list = JSON.parse(org_data.countries);
    countries_list.sort();
    var countries_list = countries_list.filter((x) => x !== "0");
    // console.log(countries_list)
    // countries_list_with_global = countries_list.push("global")
    countries_list.push("global");
    // console.log(countries_list)
    var geo_area_selected = org_data["country"];
    var country_analytics_obj = JSON.parse(org_data.country_analytics);
    var rows = "";
    for (var i = 0, len = countries_list.length; i < len; i++) {
      var country = countries_list[i];
      var label = country;
      var count_country = country_analytics_obj[country];
      var percent_country_percent = ((count_country / country_analytics_obj["global"]) * 100).toFixed(1) + "%";
      var percent_value_country = new UtilityFunctions().isFloat((count_country / country_analytics_obj["global"]) * 100) ? "(" + percent_country_percent + ")" : "";
      rows =
        rows +
        document
          .getElementById("geo_dropdown_option_element")
          .innerHTML.replace(/{country}/g, country)
          .replace(/{label}/g, label)
          .replace(/{label_selected}/g, label)
          .replace(/{percent_country}/g, percent_value_country);
    }
    var width = $(window).width();
    var elms_cont = document.querySelectorAll("[id='geo_dropdown_container']");
    for (var i = 0; i < elms_cont.length; i++)
      if (width < 600) {
        elms_cont[i].innerHTML = "";
      } else {
        elms_cont[i].innerHTML = document
          .getElementById("geo_dropdown_element")
          .innerHTML.replace(/{options}/g, dropdown_options)
          .replace(/{geo_area_selected}/g, geo_area_selected);
      }
    console.log("Org data country --- is::", org_data.country);
    this.setupGeoDropdowninOrgChart(org_data, rows);

    this.updateOrgChartCountsLastUpdated(org_data);
  }

  getFunctionalRootCounts(org_data) {
    console.log("Got to getFunctionalRootCounts with org_data::", org_data);
    var org_chart_objs = [];
    try {
      var raw = org_data && org_data.orgchart;
      if (raw && typeof raw === "string" && raw !== "undefined") {
        org_chart_objs = JSON.parse(raw);
        if (!Array.isArray(org_chart_objs)) org_chart_objs = [];
      }
    } catch (e) {
      org_chart_objs = [];
    }
    var functional_root_counts = {};
    for (var i = 0; i < org_chart_objs.length; i++) {
      if (Object.keys(functional_root_counts).includes(org_chart_objs[i].std_function_root)) {
        functional_root_counts[org_chart_objs[i].std_function_root] = functional_root_counts[org_chart_objs[i].std_function_root] + org_chart_objs[i].len_candidates;
      } else {
        functional_root_counts[org_chart_objs[i].std_function_root] = org_chart_objs[i].len_candidates;
      }
    }
    return functional_root_counts;
  }

  setupGeoDropdowninOrgChart(org_data, rows) {
    var geo_area_selected = org_data["country"];
    console.log("Thisi si the geo selected area", geo_area_selected);
    // area_selected = sessionStorage['geo_area']
    document.getElementById("geo_dropdown_container").innerHTML = document
      .getElementById("geo_dropdown_element")
      .innerHTML.replace(/{options}/g, rows)
      .replace(/{geo_area_selected}/g, geo_area_selected);
  }

  setupYearDropdowninOrgChart(org_data, rows) {
    // year_selected = org_data['country']
    // area_selected = sessionStorage['geo_area']
    if (typeof year_selected != "undefined") {
      console.log(year_selected);
      document.getElementById("year_dropdown_container").innerHTML = document
        .getElementById("year_dropdown_element")
        .innerHTML.replace(/{options}/g, rows)
        .replace(/{year_selected}/g, year_selected);
    }
  }

  getFunctionCounts(org_data) {
    console.log("Got to getFunctionCounts with org_data::", org_data);
    var org_chart_objs = [];
    try {
      var raw = org_data && org_data.orgchart;
      if (raw && typeof raw === "string" && raw !== "undefined") {
        org_chart_objs = JSON.parse(raw);
        if (!Array.isArray(org_chart_objs)) org_chart_objs = [];
      }
    } catch (e) {
      org_chart_objs = [];
    }
    var functional_counts = {};
    for (var i = 0; i < org_chart_objs.length; i++) {
      if (Object.keys(functional_counts).includes(org_chart_objs[i].std_function)) {
        functional_counts[org_chart_objs[i].std_function] = functional_counts[org_chart_objs[i].std_function] + org_chart_objs[i].len_candidates;
      } else {
        functional_counts[org_chart_objs[i].std_function] = org_chart_objs[i].len_candidates;
      }
    }
    functional_counts["unclassified"] = functional_counts["0"] || 0;
    delete functional_counts["0"];
    return functional_counts;
  }

  getAllFunctionsFromFunctionAnalytics() {
    console.log("Got to getAllFunctionsFromFunctionAnalytics ");
    var orgData = typeof org_data !== "undefined" ? org_data : null;
    if (!orgData) {
      try {
        var stored = sessionStorage["org_chart_data_for_panel"];
        if (stored && stored !== "undefined") orgData = JSON.parse(stored);
      } catch (e) {}
    }
    var functions_analytics = this.getFunctionCounts(orgData || {});
    // functions_analytics = JSON.parse(sessionStorage['functions_analytics'] )
    var functions = Object.keys(functions_analytics);
    var functions_list = [];
    for (var i = 0, len = functions.length; i < len; i++) {
      console.log(functions[i]);
      if (functions[i].includes("assist")) {
      } else if (functions[i] == "0") {
        functions_list.push("unclassified");
      } else {
        functions_list.push(functions[i]);
      }
    }
    functions_list.sort();
    return functions_list;
  }

  createFunctionalRowsLeftPanel() {
    console.log("Got to createFunctionalRowsLeftPanel ");
    var orgData = typeof org_data !== "undefined" ? org_data : null;
    if (!orgData) {
      try {
        var stored = sessionStorage["org_chart_data_for_panel"];
        if (stored && stored !== "undefined") orgData = JSON.parse(stored);
      } catch (e) {}
    }
    var functions_analytics = this.getFunctionCounts(orgData || {});
    var totalPeople = typeof total_people !== "undefined" ? total_people : (orgData && orgData.count_org) || 0;
    var functions_list = this.getAllFunctionsFromFunctionAnalytics();
    var functional_breakdown_el = document.getElementById("functional_breakdown_row_element");
    var functional_total_el = document.getElementById("functional_total_row_element");
    var functional_breakdown_rows_el = document.getElementById("functional_breakdown_rows");
    var linkedin_profile_el = document.getElementById("linkedin_profile");
    if (!functional_breakdown_el || !functional_total_el || !functional_breakdown_rows_el) return;
    var rows = "";
    for (var i = 0, len = functions_list.length; i < len; i++) {
      var pct = totalPeople ? ((functions_analytics[functions_list[i]] || 0) / totalPeople) * 100 : 0;
      rows =
        rows +
        functional_breakdown_el.innerHTML.replace(/{category}/g, functions_list[i]).replace(/{num_people}/g, pct.toFixed(1) + "%");
    }
    var totalPct = totalPeople ? 100 : 0;
    rows = rows + functional_total_el.innerHTML.replace(/{num_people}/g, totalPct.toFixed(2) + "%");
    functional_breakdown_rows_el.innerHTML = rows;
    if (linkedin_profile_el) linkedin_profile_el.innerHTML = "";
  }
  updateOrgChartCountsLastUpdated(org_data) {
    console.log("Got here to find the org chart counts and last updated::", org_data);
    if ((org_data["country"] == "global") & (org_data["type"] == "fullcompany")) {
      var company_employee_counts_obj = JSON.parse(sessionStorage["company_emp_counts"]);
      for (var i = 0; i < company_employee_counts_obj.length; i++) {
        if (company_employee_counts_obj[i]["company_id_label"] == org_data["company_id"]) {
          var company_employee_count = company_employee_counts_obj[i]["company_emp_count"];
        } else {
          var company_employee_count = 0;
        }
      }
      console.log("company_employee_count", company_employee_count);
      try {
        console.log("got here to try");
        var current_employees = org_data.count_org;
        var percent_employee = (current_employees / company_employee_count) * 100;
        if (company_employee_count == 0) {
          var twoPlacedFloat = 0;
        } else {
          var twoPlacedFloat = parseFloat(percent_employee.toFixed(1));
        }
        if (parseFloat(company_employee_count) < current_employees) {
          var current_employees = 0;
        }
        // debugger;
        if (twoPlacedFloat && current_employees && company_employee_count) {
          document.getElementById("last_updated_count_employees").innerHTML =
            '<span class="badge badge-info" onclick="new LoadDataPeopleCompaniesOrgCharts().loadModalFetchOrgChartNodeData()" style="background-color:rgb(235,235,240);font-weight:400; color:black; font-size:10pt">Historical chart: ' +
            org_data.last_updated +
            "</span><br>" +
            '<span class="badge badge-info" onclick="new LoadDataPeopleCompaniesOrgCharts().loadModalFetchOrgChartNodeData()" style="background-color:rgb(36,116,204)">Displaying: ' +
            twoPlacedFloat +
            "%" +
            '</span> <span class="badge badge-info" onclick="new LoadDataPeopleCompaniesOrgCharts().loadModalFetchOrgChartNodeData()" style="background-color:rgb(36,116,204)">' +
            current_employees +
            " of ~ " +
            company_employee_count +
            " employees</span>";
        }

        if (org_data["status"] == "blank") {
          document.getElementById("last_updated_count_employees").innerHTML =
            '<span onclick="new LoadDataPeopleCompaniesOrgCharts().loadModalFetchOrgChartNodeData()" class="badge badge-info" style="background-color:rgb(235,235,240);font-weight:400; color:black; font-size:10pt">' +
            "Org Chart Template Loaded" +
            "</span><br>";
        }
      } catch {
        console.log("got here to except catch");
        document.getElementById("last_updated_count_employees").innerHTML =
          '<span onclick = "new LoadDataPeopleCompaniesOrgCharts().loadModalFetchOrgChartNodeData()" class="badge badge-info" style="background-color:rgb(36,116,204)">Chart is representative & fractional</span><br> <span  onclick = "new LoadDataPeopleCompaniesOrgCharts().loadModalFetchOrgChartNodeData()"class="badge badge-info" style="background-color:rgb(36,116,204)">Click here to fetch names</span>';
      }
    } else {
      document.getElementById("last_updated_count_employees").innerHTML =
        '<span onclick = "new LoadDataPeopleCompaniesOrgCharts().loadModalFetchOrgChartNodeData()" class="badge badge-info" style="background-color:rgb(36,116,204)">Chart is representative & fractional</span><br> <span  onclick = "new LoadDataPeopleCompaniesOrgCharts().loadModalfetchAllFunctionDataResults()"class="badge badge-info" style="background-color:rgb(36,116,204)">Click here to fetch names</span>';
    }
  }
}


export { DrawOrgCharts };
if (typeof window !== 'undefined') {
  window.DrawOrgCharts = DrawOrgCharts;
}
